// extracted by mini-css-extract-plugin
export var dropdownContainer = "_qv-0";
export var leftAlign = "_qv-4";
export var listItem = "_qv-2";
export var listItemWrapper = "_qv-1";
export var operationText = "_qv-3";